export const isKeyPressed = (event, targetKey, fallbackKeyCode) => {
  return event?.key === targetKey || event?.keyCode === fallbackKeyCode;
};
